import useMutationApi from 'src/api/useMutationApi';

interface CreateCategoryData {
  name: string;
  description?: string;
  parentCategoryId?: string;
}

const useCreateCategory = (onSuccess?: () => void) => {
  return useMutationApi<CreateCategoryData>({
    endpoint: 'inventory-management/categories',
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useCreateCategory;
